module.exports = __webpack_public_path__ + "1920X450.a18e00953c5794a92a32.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/blog-img/press-releases/1920X450.png
// module id = ../../../../../src/assets/blog-img/press-releases/1920X450.png
// module chunks = styles